import React from 'react';
import '../styles/SimpleBalloon.css'; // CSSファイルを別途作成

const SimpleBalloon = ({ text }) => {
  return (
    <div className="now-only-balloon">
      <div className="now-text">{text}</div>
    </div>
  );
};

export default SimpleBalloon;

